import { RootState } from "src/store";
import { selectGroupsEntities } from "src/ui/containers/dashboard/groups/store/selectors";
import { selectLicensesEntities } from "src/ui/containers/dashboard/licenses/store/selectors";

import { selectProductById } from "@dashboard/products/store/selectors/products";

export type DetailsState =
    | { type: "group"; selectedId: number }
    | { type: "license"; selectedId: number }
    | { type: "client"; selectedId: number }
    | { type: "module"; selectedId: number }
    | { type: "create-rollout"; selectedId: number; codename: string }
    | { type: "rollout"; selectedId: number }
    | null;

const selectDetails = (state: RootState): DetailsState => state.devices.details;

function selectDetailsRollout(state: RootState) {
    const details = selectDetails(state);
    return details && details.type === "rollout" ? details : null;
}

function selectCreateRolloutDetails(state: RootState) {
    const details = selectDetails(state);
    return details && details.type === "create-rollout" ? details : null;
}

function selectModuleDetails(state: RootState) {
    const details = selectDetails(state);
    return details && details.type === "module" ? details : null;
}

function selectClientDetails(state: RootState) {
    const details = selectDetails(state);
    return details && details.type === "client" ? details : null;
}

function selectLicenseDetails(state: RootState) {
    const details = selectDetails(state);
    return details && details.type === "license" ? details : null;
}

function selectGroupDetails(state: RootState) {
    const details = selectDetails(state);
    return details && details.type === "group" ? details : null;
}

function selectDetailsGroup(state: RootState) {
    const details = selectGroupDetails(state);
    return details?.selectedId ? selectGroupsEntities(state)[details.selectedId] : null;
}

function selectDetailsLicense(state: RootState) {
    const details = selectLicenseDetails(state);
    return details?.selectedId ? selectLicensesEntities(state)[details.selectedId] : null;
}

function selectDetailsModule(state: RootState) {
    const details = selectModuleDetails(state);
    return details?.selectedId ? selectProductById(state, details.selectedId) : null;
}

export {
    selectClientDetails,
    selectCreateRolloutDetails,
    selectDetails,
    selectDetailsGroup,
    selectDetailsLicense,
    selectDetailsModule,
    selectDetailsRollout,
    selectGroupDetails,
    selectLicenseDetails,
};
